// Keys obtained from backend sdk/sw/crms/providers/_utils/notes.py STEP_NOTE_TITLES
export const STEP_TYPES = {
  popular: {
    keys: [
      "initialEmail",
      "followUpEmail",
      "inmail",
      "linkedinConnectionRequest",
      "meeting",
      "phoneCall",
      "unansweredPhoneCall",
    ],
  },
  email: {
    title: "Email",
    keys: [
      "emailReply",
      "outOfOfficeReply",
      "externalEmail",
      "externalEmailReply",
      "bounce",
    ],
  },
  phone: { title: "Phone", keys: ["sms", "smsReply"] },
  general: { title: "General" }, // This is a catch-all for all other note types
};
